import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { YodaColors, YodaFontWeight } from 'yoda-ui/yodaTheme';

export const chartWrapper: SxProps<Theme> = {
  width: '100%',
  height: 450,
};

export const customTooltip: SxProps<Theme> = {
  backgroundColor: YodaColors.white,
  border: `1px solid ${YodaColors.gray4}`,
  padding: 10,
};

export const customTooltipLabel: SxProps<Theme> = {
  margin: 0,
  fontWeight: YodaFontWeight.bold,
};

export const customTooltipValue: SxProps<Theme> = {
  margin: 0,
  color: YodaColors.primaryBlue,
};

export const customTooltipCumulative: SxProps<Theme> = {
  margin: 0,
  color: YodaColors.red,
};

export const loaderWrapper: SxProps<Theme> = {
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};
